import type { CarDTO } from '@/features/api/extranet/dto/Demande/CAR'
import { type TypeContextCourant } from '@/features/auth/context-app'
import type { NaturesFichiersDemandeCallback } from '@/features/domaine/regles-akto/shared'

export const Convention = 'Convention' as const
export const Programme = 'Programme' as const
export const ContratTypeLettreMission = 'ContratTypeLettreMission' as const
export const AttestationEligibiliteCar = 'AttestationEligibiliteCar' as const

const AllNatures = ['Autre', ContratTypeLettreMission, Convention, Programme, AttestationEligibiliteCar] as const
type AllNatures = (typeof AllNatures)[number]

export const getNaturesFichiersCar: NaturesFichiersDemandeCallback<CarDTO> = (
  _demande: CarDTO,
  _typeContext: TypeContextCourant,
) => {
  const nombreFichiersMinimum: { [property in AllNatures]?: number } = {}
  const nombreFichiersMaximum: { [property in AllNatures]?: number } = {}

  const obligatoires: Set<AllNatures> = new Set([
    ContratTypeLettreMission,
    AttestationEligibiliteCar,
    Convention,
    Programme,
  ])
  const facultatifs: Set<AllNatures> = new Set(['Autre'])
  const facultatifsDefaut: Set<AllNatures> = new Set([])

  return {
    obligatoires: [...obligatoires],
    facultatifs: [...facultatifs],
    facultatifsDefaut: [...facultatifsDefaut],
    /* Si absent, prend valeur par défaut. Peut-etre calculé. Exemple :
        {
            'Cerfa': 10,
            'Convention': 2
        }
    */
    nombreFichiersMaximum: nombreFichiersMaximum,
    nombreFichiersMinimum: nombreFichiersMinimum,
  }
}
